<script lang="ts">
	import { cn } from '@ui-lib/utils/utils';
	interface Props {
		class?: string;
		showText?: boolean;
	}

	let { class: className = '', showText = true }: Props = $props();
</script>

<!-- Loading state with smooth transitions -->
<div class={cn('flex flex-col items-center space-y-6 transition-all duration-300', className)}>
	<!-- Animated loading spinner -->
	<div class="relative">
		<div
			class="h-16 w-16 animate-spin rounded-full border-4 border-white/20 border-t-white/80"
		></div>
		<div class="absolute inset-0 flex items-center justify-center">
			<div class="h-8 w-8 rounded-full bg-white/10 backdrop-blur-sm"></div>
		</div>
	</div>

	<!-- Loading text -->
	{#if showText}
		<div class="text-center">
			<p class="animate-pulse text-lg font-medium text-white/80 drop-shadow-lg">Loading...</p>
		</div>
	{/if}
</div>
